import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/servicios/auth'

export function RutaProtegida({ children }: { children: ReactNode }) {
  const usuario = useAuth((s) => s.usuario)
  if (!usuario) return <Navigate to="/app/entrar" replace />
  if (usuario.debeCambiarClave || usuario.requiereConfigurarMfa) {
    // El servidor ya rechaza cualquier ruta que no sea /auth/* en este caso;
    // se manda de vuelta al login, que resuelve ambos pasos.
    return <Navigate to="/app/entrar" replace />
  }
  return <>{children}</>
}
